const ZOOM_OPTIONS = [
  ["us", "United States"],
  ["world", "World"],
];

export const MarketplaceFilterBar = ({ filters, activeFilters, onToggleFilter, zoom, onZoomChange }) => (
  <div className="mt-10 flex flex-wrap items-center justify-between gap-4">
    <div className="flex flex-wrap gap-2">
      {filters.map((f) => (
        <button
          key={f}
          onClick={() => onToggleFilter(f)}
          data-testid={`map-filter-${f.toLowerCase().replace(/\s+/g, "-")}`}
          className={`text-sm font-bold px-4 py-2 rounded-full border transition-colors ${
            activeFilters.has(f) ? "bg-rr-navy text-white border-rr-navy" : "border-rr-line text-rr-navy hover:border-rr-navy"
          }`}
        >
          {f}
        </button>
      ))}
    </div>
    <div className="flex bg-rr-surface rounded-full p-1 border border-rr-line">
      {ZOOM_OPTIONS.map(([k, l]) => (
        <button
          key={k}
          onClick={() => onZoomChange(k)}
          data-testid={`map-zoom-${k}`}
          className={`text-xs font-bold px-4 py-2 rounded-full transition-colors ${
            zoom === k ? "bg-white shadow text-rr-navy" : "text-rr-muted"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  </div>
);
